import {getStatus, getFacilityList} from '@/helper'

const pointsListStore = {
  state: {
    pointsList: {
      facility_name: null,
      equipment_names: [],
      sensors: [],
      sampling_freq: 2
    },
    pointsLoaded: false
  },
  actions: {
    async refreshPointsList (context, payload) {
      let facilityId = payload
      if (!payload) {
        if(localStorage.getItem('facilityId') === null) {
          facilityId = 1
        } else {
          facilityId = localStorage.getItem('facilityId')
        }
      }
      localStorage.setItem('facilityId', facilityId)
      let result = null
      try {
        result = await getStatus(facilityId)
      } catch(err) {
        try {
          let facilityList = await getFacilityList()
          result = await getStatus(facilityList['facilities'][0].facility_id)
        } catch (err) {

          context.commit('updatePointsLoaded')
        }
      }

      context.commit('updateProjectToken', result)
      context.dispatch('refreshConfig', {facility_name: result.facility_name})
    }
  },
  getters: {
    chillerNames: state => {
      let output = []
      for (let i in state.pointsList.equipment_details){
        if (state.pointsList.equipment_details[i].equipment_type.toLowerCase().startsWith('chiller')) {
          output.push(i)
        }
      }
      return output
    },
    minutesBetweenSamples: state => {
      return (60/state.pointsList.sampling_freq)
    }
  },
  mutations: {
    updatePointsLoaded (state) {
      state.pointsLoaded=true
    },
    updateProjectToken (state, payload) {
      state.pointsList = payload
      state.pointsList.currency = 'HKD'

      state.pointsList.electricityPrice =  {}//TODO find out typical price
      for (let i in state.pointsList.equipment_details){
        state.pointsList.electricityPrice[i] = 0.91
      }

      state.pointsLoaded = true
    }
  }
}

export default pointsListStore
